export default __webpack_public_path__ + "static/media/bbss_logo_line.6fb8976d.png";